import React, { useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import { Card, Row } from "react-bootstrap"
import ProfileVerify from "../../../components/Templates/Site/ProfileVerify";
import Matrix from "../../../components/Products/sPrivilege/Matrix";
import MessageBox from '../../../components/Common/Message/MessageBox';
import { __OBJECT_STRUCTURE_GetPrivilegeMatrix } from "../../../common/ObjectStructures/sKPI";
import MainAppContext from "../../../MainAppContext";
import { __MessageTypes } from "../../../common/Dictionaries";
import { addListPrivilegeMatrix } from "../../../services/sPrivilege/privilege.service";
import { showMessage } from "../../../common/Helpers";
import { __OBJECT_STRUCTURE_GetList } from "../../../common/ObjectStructures/Trasnversal";
import { useGetPrivilegeMatrix } from "../../../hooks/services/_Transversal/useOfTransversal";
import { useSelector } from "react-redux";

export default function Privilege(props) {
    const { token: currentAuth } = useSelector((state) => state.auth);

    const { t } = useTranslation();
    const contextSite = useContext(MainAppContext);
    const profileHasAccess = !contextSite.onlyObserver || (contextSite.securityProps.isSAdmin ||  contextSite.securityProps.isAdmin)

    const [privilegeMatrix, setPrivilegeMatrix] = useState(__OBJECT_STRUCTURE_GetPrivilegeMatrix());
    const [rowList, setRowList] = useState(null);
    useGetPrivilegeMatrix(currentAuth.token, privilegeMatrix, setPrivilegeMatrix, setRowList)

    const [messageConfig, setMessageConfig] = useState({
        message : null,
        messageType : "",
        showMessage : false,
    });

    const handleSaveAll = (rows, setRows, setFilteredRows) => {
        let updatedItemList = rows.filter(x => x.isUpdated === true);

        updatedItemList = updatedItemList.map((item) => {
            return {
                ...item,
                hasPrivilege: (item.hasPrivilege === true || item.hasPrivilege === 'Yes' || item.hasPrivilege === 'yes' || item.hasPrivilege === 1)
            };
        });
        
        addListPrivilegeMatrix(updatedItemList).then((response) => {
            if (response.data.succeeded) {
                showMessage(setMessageConfig, true, __MessageTypes.SUCCESS, t('data-lang-msg-operationperformed'))

                setRowList(rows)
                setRows(rows)
                setFilteredRows(rows)
            }
            else {
                showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
            }
        }).catch(() => {
            showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
        });
    }

    const handlerCancel = async (itemId, auxiliarList) => {
        let response = { flag: false, id: itemId, item: null};
       
        if (privilegeMatrix.matrix.length > 0 && rowList.data.length > 0) {

            const actualItemData = privilegeMatrix.matrix.find(x => x.id === itemId);

            showMessage(setMessageConfig, true, __MessageTypes.SUCCESS, t('data-lang-msg-operationperformed'))    

            rowList.data.forEach(row => {
                if (itemId === row.id) {
                    for (const property in row) {
                        row[property] = actualItemData[property]
                    }
                }
            });
    
            //setListBusinessUnit(auxiliarList);

            response.flag = true;
            response.item = 0//serviceResponse.data.data
            response.item._rowState = undefined
            return response;
        }
        else {
            showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))

            response.flag = false;
            return response;
        }
        

        return response;
    };

    const [configuration, setConfiguration] = useState({
        buttons: {
            showRowButtons: false,
            showExportData: true,
            showAddMasiveData: false,
            showAddData: false,
            showDownloadTemplate: false,
            showSaveAllData: profileHasAccess,
            groupedButtons: false
        },
        handlers: {
            handlerSaveAll: profileHasAccess ? handleSaveAll : null,
            handlerCancel: profileHasAccess ? handlerCancel : null
        },
        showPagination: false,
    });

    return (
        <div className="col-12 listWithActions">
            <ProfileVerify />
            <Card>
                <Card.Header>
                    <Card.Title className="d-flex justify-content-between">
                        <h4><b>{t('data-lang-maintainer-title-privileges')}</b></h4>
                    </Card.Title>
                </Card.Header>
                <Card.Footer>
                    <div className='float-end d-flex'>
                        
                    </div>
                </Card.Footer>
                <Card.Footer>
                    <MessageBox
                        inputParam_Message={ t('data-lang-msg-presssavealldata') }
                        inputParam_Display={ true }
                        inputParam_MessageType={ __MessageTypes.INFO }
                        inputParam_SetterMessage={ null }
                    />
                    <MessageBox
                        inputParam_Message={ messageConfig.message }
                        inputParam_Display={ messageConfig.showMessage }
                        inputParam_MessageType={ messageConfig.messageType }
                        inputParam_SetterMessage={ setMessageConfig }
                    />
                </Card.Footer>
                <Card.Body style={{width: "100%"}}>
                    <Row style={{height: "100%"}} className="align-items-center">
                        {
                            rowList && configuration && privilegeMatrix &&
                            <Matrix
                                inputParam_PageSize={rowList.length}
                                inputParam_Configuration={configuration}
                                inputParam_SetConfiguration={setConfiguration}
                                inputParam_Height={35}
                                inputParam_GroupedColumnList={[
                                    "privilegeAppName",
                                    "privilegeAppElementName",
                                    "privilegeRoleName",
                                ]}
                                inputParam_Columns={[
                                    {
                                        index: 1,
                                        key: 'privilegeAppName',
                                        name: 'Application',
                                        editable: false,
                                        editorType: 'Text',
                                        sortable: false,
                                        filterable: false,
                                        isCustomHeader: false,
                                        _type: 'string',
                                        width: 100,
                                        exportable: true
                                    },{
                                        index: 2,
                                        key: 'privilegeAppElementName',
                                        name: 'App Element Name',
                                        editable: false,
                                        editorType: 'Text',
                                        sortable: false,
                                        filterable: false,
                                        isCustomHeader: false,
                                        _type: 'string',
                                        readOnlyRenderCellType: 'isDataLang',
                                        width: 300,
                                        exportable: true
                                    },{
                                        index: 3,
                                        key: 'privilegeRoleName',
                                        name: 'Role',
                                        editable: false,
                                        editorType: 'Text',
                                        sortable: false,
                                        filterable: false,
                                        isCustomHeader: false,
                                        _type: 'string',
                                        width: 300,
                                        exportable: true
                                    },{
                                        index: 4,
                                        key: 'privilegeActionId',
                                        name: 'Privilege',
                                        editable: false,
                                        editorType: 'Select',
                                        editorOptions: privilegeMatrix.matrix.l_actions.map((item) => { return { key: item.id, text: item.name } }),
                                        sortable: true,
                                        filterable: true,
                                        isCustomHeader: false,
                                        _type: 'dropdown',
                                        readOnlyRenderCellType: 'isDropdown',
                                        exportable: false
                                    },{
                                        index: 5,
                                        key: 'hasPrivilege',
                                        name: 'Has privilege',
                                        editable: profileHasAccess ,
                                        editorType: 'Bool',
                                        sortable: false,
                                        filterable: false,
                                        isCustomHeader: false,
                                        _type: 'boolean',
                                        readOnlyRenderCellType: 'isYesNo',
                                        exportable: true
                                    }
                                ]}
                                inputParam_Rows={rowList}
                            />
                        }
                    </Row>
                </Card.Body>
            </Card>         
        </div>
    ); 
}